// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__22jrG","content":"ManualTimeModal_content__1tvke"};